export const layoutActionTypes = {
  LAYOUT: "LAYOUT",
  LAYOUT_STORE: "LAYOUT_STORE",
};
